import {Error, Label} from "@progress/kendo-react-labels";
import {DatePicker} from "@progress/kendo-react-dateinputs";
import * as React from "react";

const DateField = fieldRenderProps => {
    const {
        validationMessage,
        visited,
        label,
        id,
        valid,
        ...others
    } = fieldRenderProps;
    return <>
        <Label editorId={id} className={"k-form-label"}>
            {label}
        </Label>
        <div className={"k-form-field-wrap"}>
            <DatePicker size={"large"} format={"dd.MM.yyyy"} {...others} />
            {visited && validationMessage && <Error>{validationMessage}</Error>}
        </div>
    </>;
};

export default DateField